import script from "./ResultSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./ResultSearch.vue?vue&type=script&setup=true&lang=js"

import "./ResultSearch.vue?vue&type=style&index=0&id=d221eb88&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d221eb88"]])

export default __exports__